import { GridList } from "@client/content/controls";
import { type GridListComponentMapProps } from "@client/content/controls/GridList/component";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Filters from "./Filters/container";
import { type ProductListItemProps } from "./Item/component";

export type MapProps = RootContainerProps & {
  gridProps: GridListComponentMapProps<ProductListItemProps>;

  categoryId: string | null;
  eventId: string | null;
  hasProducts: boolean;
  order: string;
  pageSize: number;
};
export interface ActionProps {
  load: (page: number) => void;
}
export type Props = ActionProps & MapProps;

const ProductList = (props: Props) => {
  const { gridProps, load, ...rootProps } = props;
  return (
    <div>
      <Filters {...rootProps} />
      <GridList {...gridProps} load={load} />
    </div>
  );
};

export default ProductList;
